'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';

const DefaultErrorMessage = () => /*#__PURE__*/_jsx(UIErrorMessage, {
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "designComponents.errors.message"
    })
  })
});

class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      caughtError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      caughtError: true
    };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    this.reportErrors(error, errorInfo);
  }

  reportErrors(error, info = {}) {
    const {
      boundaryName
    } = this.props;

    if (window.newrelic && typeof window.newrelic.noticeError === 'function') {
      window.newrelic.noticeError(error, {
        errorBoundaryName: boundaryName
      });
    }

    Raven.captureException(error, {
      extra: Object.assign({}, info, {
        version: React.version
      }),
      tags: {
        errorBoundaryName: boundaryName
      }
    });
  }

  render() {
    const {
      children,
      renderError
    } = this.props;
    const {
      caughtError
    } = this.state;

    if (caughtError) {
      return renderError();
    }

    return children;
  }

}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  renderError: PropTypes.func,
  boundaryName: PropTypes.string.isRequired
};
ErrorBoundary.defaultProps = {
  renderError: DefaultErrorMessage
};
export default ErrorBoundary;